























































































































































import Vue from "vue";
import Component from "vue-class-component";
import rules from "../../utils/rules";
import { Auth } from "../../services/authentication/entities/authentication.interface";
import { Info } from "../../services/authentication/entities/info.interface";

@Component({
  components: {}
})
export default class SignIn extends Vue {
  valid = true;
  validChangePassword = true;
  loadingSignIn = false;
  loadingSend = false;
  snackbarEmailAndPassword = false;
  snackbarEmailSent = false;
  snackbarBlocked = false;
  snackbarUserNotRegistered = false;
  show = false;
  dialog = false;
  sendEmail = "";
  email = "";
  password = "";

  emailRules = [rules.email];
  passwordRules = [rules.notEmpty, rules.password];

  private signIn(): void {
    this.loadingSignIn = true;
    this.$store
      .dispatch("authentication/signIn", {
        email: this.email,
        password: this.password
      })
      .then((response: Auth) => {
        this.loadingSignIn = false;

        if (!response.registered) {
          this.snackbarUserNotRegistered = true;
        }

        if (response.registered && !response.authenticated) {
          this.snackbarEmailAndPassword = true;
        }

        if (response.blocked) {
          this.snackbarBlocked = true;
        }

        if (response.registered && response.authenticated) {
          const info: Info = {
            token: response.token,
            user: response.user
          };
          localStorage.setItem("info", JSON.stringify(info));
          this.$router.push("/admin/home");
        }
      });
  }

  private sendEmailToChangePassword(): void {
    this.loadingSend = true;
    this.$store
      .dispatch("authentication/sendEmailToChangePassword", {
        email: this.sendEmail
      })
      .then((response: any) => {
        this.loadingSend = false;
        this.dialog = false;

        if (response.blocked) {
          this.snackbarBlocked = true;
        }

        if (!response.verified) {
          this.snackbarUserNotRegistered = true;
        }

        if (response.sent) {
          this.snackbarEmailSent = true;
        }
      });
  }
}
